export default __webpack_public_path__ + "static/media/396.b90b2119.png";